import { useContext } from 'react';
import { MenuContext, MenuContextProps } from '../contexts/MenuContext';

const useMenu = (): MenuContextProps => {
  const context = useContext(MenuContext);
  if (!context) {
    throw new Error('useMenu must be used within an MenuProvider');
  }
  return context;
};

export default useMenu;
